import React, { FC } from 'react';
import { FileThumbnail } from '../../../../components/common/Thumbnails';
import { MediaManagerSDKFile } from '../../../../utils/media-manager-sdk';
import { IOuter } from '../ItemDemonstration.types';
import styles from './Demonstration.scss';

export const Picture: FC<IOuter> = ({ item, className, width, height, thumbnailStyle, saveRef, params }) => (
  <FileThumbnail
    wrapperClassName={className}
    file={item as MediaManagerSDKFile}
    className={styles.picture}
    width={width}
    height={height}
    style={thumbnailStyle}
    saveRef={saveRef}
    shouldUsePictureBackgroundImageImmediately
    dataHook="expanded-view-file-demonstration"
    params={params}
  />
);
